export type NonEmptyArray<T> = [T, ...T[]];

export function isNonEmptyArray<T>(arr: T[]): arr is NonEmptyArray<T> {
  return arr.length > 0;
}

export type Mutable<T> = {
  -readonly [P in keyof T]: T[P] extends (infer R)[]
    ? Mutable<R>[]
    : T[P] extends readonly (infer R)[]
      ? Mutable<R>[]
      : T[P] extends object
        ? Mutable<T[P]>
        : T[P];
};
